import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c5bd73a8")

_pushScopeId("data-v-c5bd73a8")
const _hoisted_1 = {
  id: "startOfSearchCompany",
  class: "page-section flex flex--width flex--v flex--valign-c flex--gap-50"
}
const _hoisted_2 = { class: "flex flex--v flex--valign-c flex--gap-30" }
const _hoisted_3 = { class: "flex flex--v flex--valign-c flex--gap-10" }
const _hoisted_4 = { class: "text text--primary-gradient text--bold text--size-30 text--center" }
const _hoisted_5 = { class: "text text--accent-gray-b text--medium text--size-20 text--less-gap text--center" }
const _hoisted_6 = { class: "flex flex--v flex--valign-c flex--gap-10" }
const _hoisted_7 = { class: "flex flex--v flex--valign-c flex--gap-15" }
const _hoisted_8 = { class: "text text--accent-gray-b text--medium text--size-20 text--height-24 text--less-gap text--center" }
const _hoisted_9 = { class: "text text--accent-gray-b text--medium text--size-20 text--height-24 text--less-gap text--center" }
const _hoisted_10 = { class: "input-section flex flex--width flex--gap-20" }
const _hoisted_11 = { class: "flex flex--v flex--valign-c flex--gap-30" }
const _hoisted_12 = { class: "flex flex--v flex--valign-c flex--gap-20" }
const _hoisted_13 = { class: "text text--accent-gray-b text--medium text--size-20 text--height-32 text--less-gap text--center" }
const _hoisted_14 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_15 = { class: "selectable-buttons flex flex--halign-c flex--valign-s flex--gap-10 flex--wrap" }
const _hoisted_16 = { class: "flex flex--v flex--valign-c flex--gap-30" }
const _hoisted_17 = { class: "flex flex--v flex--valign-c flex--gap-20" }
const _hoisted_18 = { class: "text text--accent-gray-b text--medium text--size-20 text--height-24 text--less-gap text--center" }
const _hoisted_19 = { class: "text text--accent-gray-b text--medium text--size-20 text--height-32 text--less-gap text--center" }
const _hoisted_20 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_21 = { class: "flex flex--v flex--valign-c flex--gap-10" }
const _hoisted_22 = { class: "text text--primary-gradient text--bold text--size-30 text--center" }
const _hoisted_23 = { class: "text text--accent-gray-b text--medium text--size-20 text--less-gap text--center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_GenericInput = _resolveComponent("GenericInput")
  const _component_GenericButton = _resolveComponent("GenericButton")
  const _component_SelectableButton = _resolveComponent("SelectableButton")
  const _component_MainPage = _resolveComponent("MainPage")

  return (_openBlock(), _createBlock(_component_MainPage, {
    title: _ctx.$trans('navigation.nav_search'),
    "title-id": 'startOfJobfuchs',
    gap: true
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$trans("search.step-1-headline")), 1),
            _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$trans("search.step-1-subheadline")), 1)
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$trans("search.help-1")), 1),
              _createVNode("span", _hoisted_9, _toDisplayString(_ctx.$trans("search.help-2")), 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode(_component_GenericInput, {
            class: "text text--primary-b text--semi-bold text--size-22",
            value: _ctx.searchString,
            placeholder: _ctx.$trans('search.search_placeholder'),
            disabled: _ctx.searchingProcess,
            onInput: _ctx.onInput
          }, null, 8, ["value", "placeholder", "disabled", "onInput"]),
          _createVNode(_component_GenericButton, {
            class: "search-btn",
            title: _ctx.$trans('search.search_button'),
            identifier: 'djf_update_search',
            searching: _ctx.searchingProcess,
            secondary: true,
            "omit-icon-when-s-m": false,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('clickSearchCompany')))
          }, null, 8, ["title", "searching"])
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _createVNode("span", _hoisted_13, [
              _createTextVNode(_toDisplayString(_ctx.$trans("search.help-3-1")) + " ", 1),
              _hoisted_14,
              _createTextVNode(" " + _toDisplayString(_ctx.$trans("search.help-3-2")), 1)
            ]),
            _createVNode("div", _hoisted_15, [
              (_openBlock(), _createBlock(_Fragment, null, _renderList(12, (number) => {
                return _createVNode(_component_SelectableButton, {
                  key: number,
                  class: "selectable-button",
                  title: _ctx.$trans(`search.help-4-${number}`).toUpperCase(),
                  circular: true,
                  onClick: ($event: any) => (_ctx.selectSector(number))
                }, null, 8, ["title", "onClick"])
              }), 64))
            ])
          ])
        ]),
        _createVNode("div", _hoisted_16, [
          _createVNode("div", _hoisted_17, [
            _createVNode("span", _hoisted_18, _toDisplayString(_ctx.$trans("search.help-5")), 1),
            _createVNode("span", _hoisted_19, [
              _createTextVNode(_toDisplayString(_ctx.$trans("search.help-6-1")) + " ", 1),
              _hoisted_20,
              _createTextVNode(" " + _toDisplayString(_ctx.$trans("search.help-6-2")), 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_21, [
          _createVNode("span", _hoisted_22, _toDisplayString(_ctx.$trans("search.help-7-1")), 1),
          _createVNode("span", _hoisted_23, _toDisplayString(_ctx.$trans("search.help-7-2")), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
})